import * as React from 'react';
import { PriceFull, PriceNew, PriceOld } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

const componentTypes = {
    full: PriceFull,
    new: PriceNew,
    old: PriceOld
};
const ariaLabelKeys = {
    full: undefined,
    new: 'common.discountedPrice',
    old: 'common.originalPrice'
};
const Price = ({ value , isCentAmount =true , currency , type , size , 'data-t': dataT ,  })=>{
    const { locale , getLabel  } = useIntl();
    const Component = componentTypes[type];
    const ariaLabelKey = ariaLabelKeys[type];
    const ariaLabel = ariaLabelKey ? getLabel(ariaLabelKey) : undefined;
    const formattedPrice = formatPrice({
        locale,
        value,
        currency,
        isCentAmount
    });
    return /*#__PURE__*/ React.createElement(Component, {
        "aria-label": ariaLabel,
        size: size,
        "data-t": dataT
    }, formattedPrice);
};

export { Price };
//# sourceMappingURL=Price.js.map
